import { fromApiServer } from "./location.js";
import Vars from "./vars.js";

if (!window.location.origin) {
  window.location.origin =
    window.location.protocol +
    "//" +
    window.location.hostname +
    (window.location.port ? ":" + window.location.port : "");
}

/*** URL UTILITIES BEGIN ***/
export const urlutils = (function () {
  var mimetypes = {
    xsl: "text/html",
    html: "text/html",
    docx: "application/msword",
    pdf: "application/pdf",
    odt: "application/vnd.oasis.opendocument.text",
    rtf: "application/rtf",
    doc: "application/msword",
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png"
  };
  function openCredentialised(event) {
    event.preventDefault();
    const href = event.target.href;
    const givenURL = new URL(href);
    if (givenURL.origin !== location.origin) {
      return false;
    }
    let windowName =
      "w_" + Date.now() + Math.floor(Math.random() * 100000).toString();
    var form = document.createElement("form");
    form.setAttribute("method", "post");
    form.setAttribute("action", href);
    form.setAttribute("target", windowName);
    let hiddenvars = new Set(["uniqueid"]);
    if (event.target.dataset["bbCredVars"]) {
      const tokens = event.target.dataset["bbCredVars"].match(/\w+/g);
      tokens.forEach(hiddenvars.add, hiddenvars);
    }
    for (let bbvar of [...hiddenvars]) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", bbvar);
      hiddenField.setAttribute("value", Vars.getVar(bbvar));
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    window.open("", windowName);
    form.submit();
    form.remove();
    return false;
  }
  function caseReport(casus) {
    return fromApiServer("report?" + Vars.querify(Vars.SESSION_KEYS, casus));
  }
  function getFiles(casus) {
    return "getfiles?" + Vars.querify(Vars.SESSION_KEYS, casus);
  }
  function isSafe(url) {
    // 1. Define the whitelist of safe protocols.
    // Note: Protocols include the colon (e.g., "https:")
    const safeProtocols = [
      "http:",
      "https:",
      "mailto:",
      "tel:",
      "ftp:"
      // Add any other protocols you explicitly trust
    ];
    try {
      // 2. Try to parse the URL using the browser's native URL constructor.
      // If the URL is relative (e.g., 'report.pdf?p=wicked:and:such'),
      // the constructor will correctly use the current page's URL as the base,
      // and the resulting protocol will be 'http:' or 'https:'.
      const parsedUrl = new URL(url, window.location.href);
      // 3. Check if the parsed protocol is in the safe list.
      // This reliably ignores colons that appear later in the path or query.
      return safeProtocols.includes(parsedUrl.protocol);
    } catch (_err) {
      return false;
    }
  }
  function isJS(url) {
    return !isSafe(url);
  }
  function isEmptyish(url) {
    return url[0] === "?";
  }
  var JSAlertMessage =
    "ALERT:\nIt looks like someone is trying to eavesdrop on you," +
    " trying to evaluate JavaScript code. " +
    "This person may want to steal private information " +
    "from you or other persons. " +
    "For your safety and that of others, " +
    "please contact this website " +
    "to report this message.";
  return {
    openCredentialised,
    isJS,
    isEmptyish,
    JSAlertMessage,
    getFiles,
    caseReport,
    mimetype: function (url) {
      const absoluteURL = new URL(
        fromApiServer(url),
        `${location.protocol}${location.host}${location.pathname}`
      );
      const filename = absoluteURL.pathname.endsWith("/getfile")
        ? new URLSearchParams(absoluteURL.search).get("filename")
        : absoluteURL.pathname.split("/").pop();
      if (!filename) return null;
      const ext = filename.match(/\.([^?.]+)$/),
        mimetype = ext && mimetypes[ext[1]];
      if (!mimetype) return null;
      return {
        mimetype: mimetype,
        ext: ext[1]
      };
    }
  };
})();
/*** URL UTILITIES END ***/
